<template>
  <div class="modal-finances-table">
    <div class="labels row" :class="{
        'right-padding': this.hasScroll
      }">
      <div class="column" style="width: 10%">rBr</div>
      <div class="column" style="width: 20%">Ime i prezime</div>
      <div class="column" style="width: 20%">Opis posebnog dela</div>
      <div class="column" style="width: 20%">Email</div>
      <div class="column" style="width: 20%">Početno stanje</div>
      <div class="column" style="width: 10%">Dodaj člana</div>
    </div>
    <div v-if="loading">Ucitavanje podataka....</div>
    <div v-else ref="rows" class="rows" :style="{ 'max-height': height + 'px' }">
      <div class="row" v-for="row in data" :key="row.id" :class="{ 'emit-row': checkable }">
        <div class="column" style="width: 10%">
          <div>{{ row.ordinal | formatEmptyFields }}</div>
        </div>
        <div class="column" style="width: 20%">
          <div>{{ row.user_full_name | formatEmptyFields }}</div>
        </div>
        <div class="column" style="width: 20%">
          <input
            class="form-control balance-input"
            placeholder="Unesite opis posebnog dela"
            @focus="errorOccurred = false"
            v-model.lazy="row.div_desc"
          />
        </div>
        <div class="column" style="width: 20%">
          <input
            class="form-control balance-input"
            placeholder="Unesite email"
            @focus="errorOccurred = false"
            v-model.lazy="row.email"
          />
        </div>
        <div class="column" style="width: 20%">
          <input
            class="form-control balance-input"
            placeholder="Unesite početno stanje stanara"
            @focus="errorOccurred = false"
            v-model.lazy="row.balance"
            v-money="{}"
          />
        </div>
        <div class="bulk-add-checkbox-input" style="width: 10%">
          <checkbox
            size="small"
            :checked="row.checked"
            @change.native="row.checked = !row.checked"
            v-if="checkable"
          ></checkbox>
        </div>
      </div>
      <!-- <div class="more-dots">
        <h3 v-if="count > 5">...</h3>
      </div>-->
    </div>
  </div>
</template>
<script>
import checkbox from '@/components/common/Checkbox.vue';
import { addSeparatorMixin, formatEmptyFieldsMixin } from '@/mixins/mixins.js';
export default {
  props: {
    data: { type: Array, required: true },
    height: { requried: false },
    checkable: { type: Boolean, default: false },
    loading: { type: Boolean, default: true }
  },
  mixins: [addSeparatorMixin, formatEmptyFieldsMixin],
  components: {
    checkbox
  },
  computed: {
    getDataLength() {
      return this.data.length;
    }
  },
  data() {
    return {
      count: 0,
      hasScroll: false
    };
  }
};
</script>
<style lang="scss">
.bulk-add-checkbox-input {
  label {
    height: 100%;
    width: 100%;
    span {
      position: absolute !important;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%);
    }
  }
}
.modal-finances-table {
  // max-height: calc(100% - 35px);
  // height: calc(100% - 35px);
  height: 100%;
  max-height: 100%;
  margin-bottom: 0;
  font-size: 0.9rem;
  position: relative;
  z-index: 0;

  .right-padding {
    .column:last-of-type {
      padding-right: 0.7rem;
    }
  }

  .trashcan-padding {
    padding-right: 3rem;
  }

  .checkbox-padding {
    padding-right: 2.1rem;
  }

  .rows {
    max-height: calc(100% - 22px);
    overflow-y: auto;
    // padding: 0.5rem 0;

    .row:nth-child(2n) {
      background-color: rgba(0, 0, 0, 0.05);
    }

    .row:hover {
      background-color: rgba(0, 0, 0, 0.178);
    }

    .emit-row {
      cursor: pointer;
    }

    // .row:hover .trash--mod {
    //   display: none;
    // }
    .row {
      padding: 3px 0;
      height: 15%;
      width: 100% !important;
      display: flex;
      flex-wrap: nowrap;
      .column {
        text-align: left;
        // flex: 1;
        word-break: break-word;
        display: flex;
        align-items: center;
        padding: 0 4px;
        input {
          width: 100%;
        }
      }

      .trash--mod {
        padding-right: 5px;
        margin: auto 0;
        transition: 0.2s all;
        margin-left: 1.8rem;
      }

      .trash--mod:hover {
        color: red;
        cursor: pointer;
      }

      .checkbox {
        margin: auto 0;
        margin-right: 20px;
      }

      .checkbox:hover {
        cursor: pointer;
      }
    }
  }
  .labels {
    border-bottom: 1px solid gray;
    .column {
      font-weight: 600;
    }
  }
  .more-dots {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 10%;
    width: 100%;
    h3 {
      font-size: 3rem;
      margin-top: -36px;
      text-align: center;
    }
  }

  .balance-input {
    width: auto;
  }
}
</style>
